import { useState, useEffect } from "react";
import "./CollectionsFavorites.css";
import { useSelector } from "react-redux";
import {
  selectCollectionFavorites,
  selectCollections,
  selectUser,
} from "../../redux/features/appData";
import { Collection, CollectionFavorite } from "winslow-core";
import { CollectionCard } from "./CollectionCard";
import { CollectionCardZero } from "./CollectionCardZero";
import { CollectionQuestionCount } from "../../services/CollectionService.types";
import { apiGetCollectionQuestionCountForUserInWorkspace } from "../../services/CollectionService";

export const CollectionsFavorites = () => {
  const storeUser = useSelector(selectUser);
  const collections = useSelector(selectCollections);
  const collectionFavorites = useSelector(selectCollectionFavorites);

  const [collectionQuestionCounts, setCollectionQuestionCounts] = useState<
    CollectionQuestionCount[] | null
  >(null);

  useEffect(() => {
    if (storeUser && !collectionQuestionCounts) {
      (async () => {
        if (storeUser.currentWorkspaceId) {
          const cqCount = await apiGetCollectionQuestionCountForUserInWorkspace(
            storeUser.currentWorkspaceId,
            storeUser.id
          );

          setCollectionQuestionCounts(cqCount);
        }
      })();
    }
  }, []);

  let faveCollections: Collection[] = [];

  if (collections && collectionFavorites) {
    faveCollections = collections.filter((collection: Collection) => {
      const index = collectionFavorites.findIndex(
        (fave: CollectionFavorite) => {
          return fave.collectionId === collection.id;
        }
      );

      return index !== -1;
    });
  }

  return (
    <div id="collections-favorites">
      <div className="collections-favorites-title">Favorites</div>
      <div className="collections-favorites-grid-container">
        {faveCollections &&
          faveCollections.map((collection: Collection) => {
            return (
              <>
                <div className="collections-favorites-grid-item">
                  <CollectionCard
                    key={collection.id}
                    collection={collection}
                    questionCounts={collectionQuestionCounts}
                  />
                </div>
              </>
            );
          })}
        {collections && collections.length === 0 && <CollectionCardZero />}
      </div>
    </div>
  );
};
